<template>

    <div class="card-product">
        <div class="card-product-body">
            <div class="justify-content-center">
                <div class="item-block">
                    <span v-if="eco" class="item_icon_info left">
                        <img class="eco" src="/img/iconos/icon_ecologico.svg" alt="icon_ecologico.svg" title="Producto ecológico">
                        <br><span style="font-weight: bold;color: #4d4d4d;">ECO</span>
                    </span>
<!--                    <span v-if="articulo.zona_actual" :class="(eco)?'item_icon_info left bot':'item_icon_info left'">-->
<!--                        <img v-if="Object.values(articulo.zona_actual).find(z=>z.zona=='CÁLIDA')" src="/img/iconos/icon_calida.svg" alt="icon_calida.svg" title="Producto de zona cálida">-->
<!--                        <br>-->
<!--                        <img v-if="Object.values(articulo.zona_actual).find(z=>z.zona=='FRÍA')" src="/img/iconos/icon_fria.svg" alt="icon_fria.svg" title="Producto de zona fría">-->
<!--                    </span>-->
                    <span v-if="inOferta" class="item_icon_info oferta">
                        <img src="/img/iconos/icon_new_oferta.png" alt="icon_new_oferta.png" title="Producto en oferta">
                    </span>
                    <!--<span v-if="articulo.bp_seleccion" class="item_icon_info right">
                        <img src="/img/bp_seleccion.svg" alt="bp_seleccion.svg" title="Producto recomendado por Babyplant">
                    </span>
                    <span v-if="inOferta" :class="(articulo.bp_seleccion)?'item_icon_info right bot':'item_icon_info right'">
                        <img src="/img/iconos/icon_oferta.svg" alt="icon_oferta.svg" title="Producto en oferta">
                    </span>-->
                    <a :href="art_details">
                        <div class="img-wrapper">
                            <img :src="articulo.img_verify" alt="articulo-img_verify" class="product-img">
                        </div>
                    </a>
                    <div class="item-info">
                        <a class="item-link" :href="art_details">
                            <h4>
                                <template v-if="eco">ECO</template> {{articulo.especie_verify.nombre | truncate(15)}}
                                <br>
                                <span class="mote" :title="articulo.mote_verify.nombre">{{articulo.mote_verify.nombre | truncate(19)}}</span>
                                <br>
                                <span :title="articulo.nombre_verify">{{articulo.nombre_verify | truncate(26)}}</span>
                                <img src="/img/logos/Logo-Euro-Agricultura.png" alt="Logo ECO" style="width: 20px" v-if="eco" title="Producto ecológico">
                                <i class="fa fa-info-circle"></i>
                            </h4>
                        </a>

                        <p class="precio_minimo_garantizado">
                            <img src="/img/iconos/icon_precio_minimo_garantizado.svg" alt="icon_precio_minimo_garantizado.svg">
                            Precio mínimo garantizado
                            <i v-b-modal.modal-preciominimo class="fa fa-info-circle cursor_pointer"></i>
                        </p>

                        <!-- INDICADORES DE PRECIOS -->
                        <span class="price" v-if="!inOferta">
                            {{precio | round}} € <span>IVA incluido</span>
                        </span>
                        <span class="price_oferta" v-else>
                            <span class="last">{{precio | round}} €</span>
                            <span class="new">{{precio_oferta | round}} €</span>
                            <span>IVA incluido</span>
                        </span>

                        <br>

                        <span class="price" v-if="!inOferta">
                            <span>Precio total</span>
                            {{precio*cantidad | getAhorro(cantidad,true,this.$root.tipo_cliente) | round}} €
                            <span>IVA incluido</span>
                        </span>
                        <span class="price_oferta" v-else>
                            <span>Precio total</span>
                            <span class="last">{{precio*cantidad | getAhorro(cantidad,true,this.$root.tipo_cliente) | round}} €</span>
                            <span class="new">{{precio_oferta*cantidad | getAhorro(cantidad,true,this.$root.tipo_cliente) | round}} €</span>
                            <span>IVA incluido</span>
                        </span>

                        <div v-if="this.articulo.average_valoracion !== null" class="rating-wrapper">
                            <star-rating :read-only="true" :rating="this.articulo.average_valoracion" :show-rating="false" :star-size="20"></star-rating> <b>({{ this.articulo.num_valoracion }})</b>
                        </div>
                        <div v-else class="rating-wrapper"></div>

                        <div class="formato-bandeja-band">
                            Formato de bandejas
                        </div>

                        <!-- FORMATO DE BANDEJA -->
                        <div class="selectores container">
                            <div class="row select_item n_alveolos_item" v-for="bandeja in bandejas" :key="bandeja">
                                <div class="col-9 title">
                                    Nº Alvéolos por bandeja
                                </div>
                                <div class="col-3 pl-0 pl-0 text-center">
                                    <div class="n-alveolos-btn" @click="select_bandeja = bandeja" :class="{'selected': select_bandeja === bandeja}">
                                        {{bandeja}}
                                    </div>
                                </div>
                            </div>
                            <div class="row select_item">
                                <div class="col-9 title">
                                    Nº semillas por alvéolo
                                </div>
                                <div v-if="semillas.length>1" class="col-3 pl-0 text-center">
                                    <select2 name="semillas_alveolo" @change="setData()" v-model="select_semillas" :config-options="{minimumResultsForSearch: Infinity,dropdownCssClass: 'select2-text-center'}">
                                        <option v-for="combinacion in semillas" :key="combinacion.semilla_alveolo" :value="combinacion.semilla_alveolo">
                                            {{combinacion.semilla_alveolo}}
                                        </option>
                                    </select2>
                                </div>
                                <div class="col-3 pl-0 disabled text-center" v-else>
                                    <select2 name="semillas_alveolo" @change="setData()" v-model="select_semillas" :config-options="{minimumResultsForSearch: Infinity,dropdownCssClass: 'select2-text-center'}" disabled>
                                        <option v-for="combinacion in semillas" :key="combinacion.semilla_alveolo" :value="combinacion.semilla_alveolo">
                                            {{combinacion.semilla_alveolo}}
                                        </option>
                                    </select2>
                                </div>
                            </div>
                        </div>

                        <hr class="divisor-formato-cantidad">

                        <!-- BLOQUE AHORRO -->
                        <div class="ahorro-block-wrapper">
                            <div v-if="stock>=3&&this.$root.tipo_cliente!=1" :class="'ahorro_block row '+ahorro_block">
                                <div class="title_block col-9" v-show="cantidad>=3">
                                    <span>Está ahorrando</span>
                                </div>
                                <div class="title_block col-3" v-show="cantidad>=3">
                                    <span>{{ahorro | getAhorro(cantidad) | round}}€</span>
                                </div>
                                <div class="title_block col-9">
                                    <span>Descuento por volumen</span>
                                </div>
                                <div class="title_block col-3">
                                    <img class="ahorro_icon" :src="'/img/iconos/icon_descuento'+ahorro_icon+'.svg'" alt="ahorro_icon">
                                    <i class="fas fa-info-circle cursor_pointer" @mouseover="openInfoWindow('info_descuento')" @mouseleave="openInfoWindow('info_descuento')"></i>
                                    <windows-info v-cloak ref="info_descuento" back-color="green" in-product="true">
                                    <span slot="header">
                                        Se aplicarán los siguientes descuentos por volumen de compra
                                        siempre que se trate de un mismo artículo.
                                    </span>
                                        <span slot="footer">
                                        <strong>De 3 a 6 bandejas</strong><br>
                                        <span>Descuento de 0,33€ por bandeja</span>
                                        <br><br>
                                        <strong>De 7 a 11 bandejas</strong><br>
                                        <span>Descuento de 0,66€ por bandeja</span>
                                        <br><br>
                                        <strong>Más de 12 bandejas</strong><br>
                                        <span>Descuento de 1,00€ por bandeja</span>
                                    </span>
                                    </windows-info>
                                </div>
                            </div>
                        </div>


                        <!--<div v-else class="no_stock">
                        </div>-->
                        <!--<div v-else class="ahorro_block row disabled no_stock">
                            <span>No es posible en estos momentos el descuento por volumen</span>
                        </div>-->

                        <!-- UNIDADES -->
                        <div class="unidades row">
                            <div class="title_block col-7">
                                <span>Cantidad bandejas</span>
                            </div>
                            <div class="value col-5">
                                <div class="control" @click="minusUnits()">-</div>
                                <div class="number">{{cantidad}}</div>
                                <div class="control" @click="(!full_stock)?addUnits():''">+</div>
                            </div>
                        </div>

                        <!-- ADD CART BUTTON -->
                        <div>
                            <load-spiner v-if="loadAddCart"></load-spiner>
                            <button v-else class="btn btn-add-cart" @click="addToOrder($event)">
                                Añadir al pedido
                            </button>
                        </div>
                        <windows-info v-cloak ref="info_ayuda_form" back-color="red" in-product="true" :articulo="articulo" :combinacion="combinacion_selected">
                            <div slot="header">
                                <h4 class="title">¿Necesitas más de esta variedad?</h4>
                                <h4 class="title_alt">¡Contáctanos!</h4>
                            </div>
                            <div slot="button">
                                <a class="alter-btn-green">
                                    <span>
                                        Rellenar formulario
                                    </span>
                                </a>
                            </div>
                            <div slot="agradecimiento">
                                <div class="py-3 px-1">
                                    <h2 class="title">¡Gracias!</h2>
                                    <h3 class="title_alt">Recuerda finalizar el proceso si quieres comprar el disponible de esta variedad</h3>
                                </div>
                            </div>
                        </windows-info>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import WindowsOutStockComponent from "../../../partials/WindowsOutStockComponent";
    import StarRating from 'vue-star-rating';
    export default {
        components: {WindowsOutStockComponent, StarRating},
        props: ['articulo','add-week','eco'],
        data() {
            return {
                precio: "999",
                inOferta: false,
                precio_oferta: "999",


                stock: "",
                cantidad: "1",
                full_stock: false,

                bandejas: [],
                semillas: "",
                select_bandeja: "",
                select_semillas: "",
                combinacion_selected: "",

                ahorro: "0",
                ahorro_icon: "",
                ahorro_block: "",

                art_details: "",

                loadAddCart: false
            }
        },
        mounted() {
            this.art_details = "/products/"+this.articulo.id+"-"+this.articulo.slug+"/"+this.addWeek+"/"+this.eco;

            this.bandejas = [...new Set(this.articulo.combinaciones_c.map(item => item.bandeja_id).sort().reverse())];

            let combinacionesBandejaMasGrande = this.articulo.combinaciones_c.filter(c => c.bandeja_id === this.bandejas[0]);

            for(var i=0;i<combinacionesBandejaMasGrande.length;i++) {
                if (this.precio > combinacionesBandejaMasGrande[i].precios[0].precio_final_iva) {
                    this.setData(combinacionesBandejaMasGrande[i]);
                }
            }

            for(var i=0;i<this.articulo.combinaciones_c.length;i++){
                if(!this.bandejas.indexOf(this.articulo.combinaciones_c.bandeja_id)){
                    this.bandejas.push(this.articulo.combinaciones_c.bandeja_id);
                }
            }
        },
        watch: {
            cantidad: function (val) {
                if (val>=12) {
                    this.ahorro_icon = 'full';
                }else if (val>=7) {
                    this.ahorro_icon = 'medium';
                }else if (val>=3) {
                    this.ahorro_icon = 'low';
                }else{
                    this.ahorro_icon = '';
                }
                if (val<3) {
                    this.ahorro_block = 'disabled';
                }else{
                    this.ahorro_block = '';
                }
            },
            select_bandeja: function (val) {
                this.semillas = this.articulo.combinaciones_c.filter(x => x.bandeja_id == val);
                this.select_semillas = this.semillas[0].semilla_alveolo;
                this.setData();
            },
        },
        methods: {
            addToOrder: function (event) {
                //var imgtodrag = $(event.target).closest(".item-block").children("a").children("img");
                var that = this;
                this.loadAddCart = true;
                if(this.combinacion_selected) {
                    var line = {
                        articulo: this.articulo,
                        articulo_id: this.articulo.id,
                        bandeja: this.combinacion_selected.bandeja,
                        bandeja_id: this.combinacion_selected.bandeja.id,
                        semilla_alveolo: this.combinacion_selected.semilla_alveolo,
                        unidades: this.cantidad,
                        ecologico: this.eco
                    };

                    this.$emit('addLineToOrder',line);

                    this.loadAddCart = false;
                }else{
                    Vue.toasted.show('Selecciona un formato', {
                        type: "error",
                        duration: 3000
                    });
                }
            },
            addUnits: function () {
                if(this.stock) {
                    if (this.cantidad < this.stock) {
                        this.cantidad++;
                    } else {
                        /*Vue.toasted.show('No hay mas unidades disponibles', {
                            type: "warning",
                            duration: 3000
                        });*/
                        this.openInfoWindow('info_ayuda_form');
                        this.full_stock=true;
                    }
                }else{
                    Vue.toasted.show('Selecciona un formato', {
                        type: "error",
                        duration: 3000
                    });
                }
            },
            minusUnits: function () {
                if(this.cantidad>1) {
                    this.cantidad--;
                    this.full_stock=false;
                }
            },
            setData: function (combinacion="") {
                if(combinacion){
                    this.combinacion_selected = combinacion;
                    this.select_bandeja = this.combinacion_selected.bandeja_id;
                    this.select_semillas = this.combinacion_selected.semilla_alveolo;
                } else {
                    this.combinacion_selected = this.articulo.combinaciones_c.find(x => x.bandeja_id == this.select_bandeja && x.semilla_alveolo == this.select_semillas);
                }

                this.cantidad = 1;
                this.full_stock = false;
                this.inOferta = (this.combinacion_selected.precios[0].oferta>0);
                this.precio = this.combinacion_selected.precios[0].precio_final_iva;

                if(this.inOferta){
                    var discount = (this.precio*this.combinacion_selected.precios[0].oferta)/100;
                    this.precio_oferta = this.precio-discount;
                }

                this.stock = _.sumBy(this.combinacion_selected.partidas_c, function (partida) {
                    return partida.stock;
                });
            },
            openInfoWindow: function (ventana) {
                var window = this.$refs[ventana];
                window.active=!window.active;
            },
            flyToCart: function (imgtodrag) {

                if($(".second-row-header").hasClass("d-none")){
                    var cart = $('#shopping_cart_icon_1');
                }else{
                    var cart = $('#shopping_cart_icon_2');
                }

                if (imgtodrag) {
                    var imgclone = imgtodrag.clone()
                        .offset({
                            top: imgtodrag.offset().top,
                            left: imgtodrag.offset().left
                        })
                        .css({
                            'opacity': '0.5',
                            'position': 'absolute',
                            'height': '150px',
                            'width': '150px',
                            'overflow' : 'hidden',
                            'z-index': '99999999999999999999'
                        })
                        .appendTo($('body'))
                        .animate({
                            'top': cart.offset().top + 10,
                            'left': cart.offset().left + 10,
                            'width': 37,
                            'height': 37
                        }, 1000, 'easeInOutExpo');

                    setTimeout(function () {
                        cart.effect("shake", {
                            times: 2
                        }, 200);
                    }, 1500);

                    imgclone.animate({
                        'width': 0,
                        'height': 0
                    }, function () {
                        $(this).detach()
                    });
                }

            }
        }
    }
</script>

<style>
    .select2-text-center li.select2-results__option {
        text-align: center;
        margin-left: -12px;
    }

    .formato-bandeja-band {
        background-color: #0071bd;
        margin-left: -15px;
        margin-right: -15px;
        padding-left: 15px;
        padding-right: 15px;
        color: #fff;
        font-weight: bold;
        line-height: 2;
        margin-top: 1rem;
    }

    .card-product .selectores .select_item .title {
        color: #0071bd;
    }

    .card-product .selectores .select2-container--default .select2-selection--single {
        border: 1px solid #0071bd;
    }

    .card-product .selectores .select2-container--default .select2-selection--single .select2-selection__rendered {
        color: #0071bd;
    }

    .card-product .selectores .select2-container--default .select2-selection--single .select2-selection__arrow b {
        border-color: #0071bd transparent transparent transparent;
    }

    .n_alveolos_item {
        padding-bottom: 4px;
    }

    .n-alveolos-btn {
        border: 1px solid #0071bd;
        height: 28px;
        line-height: 28px;
        border-radius: 4px;
        cursor: pointer;
        user-select: none;
        color: #0071bd;
    }

    .n-alveolos-btn:hover {
        background-color: #1288d7;
        color: #fff;
    }

    .n-alveolos-btn.selected {
        background-color: #0071bd;
        color: #fff;
    }

    .selectores.container {
        padding: 1rem 0;
        min-height: 112px;
        max-height: 112px;
    }

    hr.divisor-formato-cantidad {
        margin-left: -15px;
        margin-right: -15px;
        border-color: #0071bd;
        margin-top: 0;
    }

    .card-product .item-info .unidades {
        line-height: 28px;
    }

    .card-product .item-info .unidades .title_block {
        color: #0071bd;
        font-weight: bold;
    }

    .card-product .item-info .unidades .value {
        border-radius: 4px;
        border-color: #0071bd;
    }

    .card-product .item-info .unidades .value {
        display: flex;
    }

    .card-product .item-info .unidades .value .control {
        margin: 0;
        padding: 0 10px;
        background-color: #0071bd;
        color: #fff;
        user-select: none;
    }

    .card-product .item-info .unidades .value .number {
        flex: 1 0 auto;
        color: #0071bd;
    }

    .card-product .item-info .ahorro_block {
        margin-top: unset;
        margin-bottom: unset;
    }

</style>

<style scoped>
    .img-wrapper {
        min-width: 100%;
        max-width: 100%;
        min-height: 280px;
        max-height: 280px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .rating-wrapper {
        min-height: 23px;
        max-height: 23px;
        display: flex;
        align-items: center;
        line-height: 1em;
    }

    .ahorro-block-wrapper {
        min-height: 58px;
        max-height: 58px;
        display: flex;
        align-items: flex-end;
    }

    .ahorro-block-wrapper > * {
        flex: 1 1 auto;
    }
</style>
